(function () {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('mon-bilan', {
            abstract: true,
             parent: 'bhs'
        });
    }
})();
